export function PaymentsTabHeader() {
    return (
            <div className="flex flex-wrap items-start justify-between gap-3 sm:gap-4">
                <div className="min-w-0 flex-1 rounded-xl border border-amber-200/90 bg-gradient-to-br from-amber-50 to-amber-50/30 px-3 py-3 shadow-sm sm:px-3">
                    <p className="text-sm leading-relaxed text-amber-950/90">
                        <span className="font-semibold text-amber-900">Note:</span> If you need assistance contact your Liberty
                        Success Manager to set up this information.
                    </p>
                </div>
            </div>
    )
}
